export default __webpack_public_path__ + "static/media/recreate-disabled.278ea242.svg";